// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
} from '@atlassian/react-resource-router';

import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	ChangeCalendarViewSettingsResource,
	ChangeCalendarViewSettingsResponse,
} from './types.tsx';

const getData = async (
	routerContext: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<ChangeCalendarViewSettingsResponse> => {
	if (!routerContext.match.params.projectKey) {
		return;
	}

	const { cloudId } = tenantContext;
	const { projectKey } = routerContext.match.params;

	try {
		const response: ChangeCalendarViewSettingsResponse = await performGetRequest(
			`/gateway/api/jsm/change-management/view/api/v1/cloudId/${cloudId}/settings/project/${projectKey}`,
		);

		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getChangeCalendarViewSettings',
				packageName: 'jiraRouterResourcesJsmChangeCalendar',
				teamName: 'jenga',
			},
			error,
		});

		throw error;
	}
};

export const changeCalendarViewSettingsResource =
	createResource<ChangeCalendarViewSettingsResource>({
		getData,
		isBrowserOnly: true,
		type: 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
		maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
		getKey: () => 'CHANGE_CALENDAR_VIEW_SETTINGS_RESOURCE',
	});
